import { ReactElement } from 'react';
import {
  ArrowRightArrowLeft,
  Box,
  FileContract,
  MoneyBillTransfer,
  ClipboardListCheck
} from '@unified-checkout/design-system/icons/index';

export const getReportsTypeCellIcon = (
  type: string
): ReactElement<"svg"> => {
  if (type?.toLowerCase().includes('transaction')) {
    return ArrowRightArrowLeft;
  }
  if (type?.toLowerCase().includes('order')) {
    return Box;
  }
  if (type?.toLowerCase().includes('invoice')) {
    return FileContract;
  }
  if (type?.toLowerCase().includes('transfer')) {
    return MoneyBillTransfer;
  }
  if (type?.toLowerCase().includes('custom')) {
    return ClipboardListCheck;
  }
  return ClipboardListCheck; 
};